import RequestPasswordForm from './RequestPasswordFormContainer';

export default RequestPasswordForm;
